import React, { Component } from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Collage from 'components/custom/Collage'
import { MODULE_NAME } from './constants'
import injectSagas from 'helpers/injectSagas'
import Sagas from './sagas'

import {
    thumbnailLinksSelector,
    thumbnailLoadingSelector,
    thumbnailFileSelector
} from './selectors'
import {
    fetchFileForThumbnail,
    
} from './actions'
import { 
  updatePreviewShow 
} from 'containers/Project/FilePreview/actions'
import {
  fetchFileForPreview,
} from 'containers/Project/FileSection/actions'

const mapStateToProps = (state) => {
    return {
      thumbnailLinks: thumbnailLinksSelector(state),
      thumbnailFile: thumbnailFileSelector(state),
      thumbnailLoading: thumbnailLoadingSelector(state)
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      fetchFileForThumbnail: (id) => dispatch(fetchFileForThumbnail(id)),
      fetchFileForPreview: (id, name) => dispatch(fetchFileForPreview(id, name)),
      openPreview: () => dispatch(updatePreviewShow(true))
    }
  }

class Thumbnail extends Component {

    onPreview = () => {
      const {
        thumbnailFile,
        fetchFileForPreview,
        openPreview
      } = this.props
      const {
        fileId,
        name
      } = thumbnailFile
      fetchFileForPreview(fileId, name)
      openPreview()
    }

    getThumbnailSettings = (thumbnailLinks) => {
      const {
        fetchFileForPreview,
        openPreview
      } = this.props
      const num = thumbnailLinks.length
      let setting = {
        width: 170,
        layout: [1],
        photos: thumbnailLinks.map(({url, fileId, name}) => ({source: url, fileId, name})),
        showNumOfRemainingPhotos: true,
        onClick: ({fileId, name}) => {
          fetchFileForPreview(fileId, name)
          openPreview()
        }
      }
      if (num === 0) {
        return setting
      }
      else if (num === 1) {
        setting.height = ["120px"]
        return setting
      }
      else {
        setting.layout = [1, Math.min(num - 1, 3)]
        setting.height = ["80px", "50px"]
        return setting
      }
    }

  render() {
    const {
      thumbnailLinks,
      thumbnailLoading
    } = this.props
    const renderReady = !thumbnailLoading && thumbnailLinks.length > 0
    return (
      <div className={styles.thumbnail}>
        {renderReady && <Collage {...this.getThumbnailSettings(thumbnailLinks)}/>}
      </div>
      )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: Sagas })
const withStyles = CSSModules(styles)
const enhance = compose(
    withConnect,
    withSagas,
    withStyles,
)

export default enhance(Thumbnail)
